/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentSasUrlDto } from '../../models/document-sas-url-dto';

export interface CreateEmergencyAlertPlanPdf$Params {

/**
 * customer id
 */
  customerId: number;
}

export function createEmergencyAlertPlanPdf(http: HttpClient, rootUrl: string, params: CreateEmergencyAlertPlanPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentSasUrlDto>> {
  const rb = new RequestBuilder(rootUrl, createEmergencyAlertPlanPdf.PATH, 'post');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentSasUrlDto>;
    })
  );
}

createEmergencyAlertPlanPdf.PATH = '/customers/{customerId}/emergency-alarm-plan/pdf';
